class Prefetcher {
  links = new Map()
  fetch (url, opts) {
    const existsAlready = this.links.get(url);
    if (!existsAlready && !!url) {
      const res = document.createElement('link');
      res.rel = 'prefetch';
      res.href = url;
      if (opts.as) res.as = opts.as;
      this.links.set(res);
      document.head.appendChild(res);
    }
  }
}
const singleton = new Prefetcher();
export default singleton;
